import { Skeleton } from "@/components/ui/skeleton";

export function WorkspaceSkeleton() {
  return (
    <div className="flex h-full flex-col">
      {/* Main content area skeleton */}
      <div className="flex-1 min-h-0 p-4">
        <Skeleton className="h-full w-full rounded-lg" />
      </div>
      
      {/* Console panel skeleton */}
      <div className="h-64 shrink-0 border-t border-border">
        <div className="flex h-full flex-col">
          {/* Console header */}
          <div className="flex items-center justify-between border-b border-border px-4 py-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-4 w-20" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-6 w-6 rounded" />
              <Skeleton className="h-6 w-6 rounded" />
            </div>
          </div>
          
          {/* Console content */}
          <div className="flex-1 p-4 space-y-3">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-1/3" />
          </div>
        </div>
      </div>
    </div>
  );
}
